import React, { useEffect, useState } from 'react';
const HOTMART = 'https://checkout.recursostop.shop/cart/45770493690052:1';
export function FloatingCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-50 md:hidden p-3 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] transition-transform duration-300 ease-out ${show ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-81">
      <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="block w-full py-4 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-lg rounded-full text-center shadow-lg" data-id="element-82">
        🔥 QUIERO MI MEGAPACK
      </a>
    </div>;
}